<app-modal-header>
  <div class="flex justify-center items-center gap-4">
    <svg-icon class="h-7 w-7 flex text-modules-eclass-700" src="assets/icons/icon-video.svg"></svg-icon>
    <hr app-modal-divider />
    <div class="flex items-center overflow-hidden">
      @for (bread of breadcrumb$ | async; track $index) {
        <p
          class="flex cursor-pointer whitespace-nowrap px-1 text-lg font-medium"
          [ngClass]="{ 'text-base-gray-300': !$last, 'text-black': $last }"
          (click)="onNavigate(bread.path, $index)"
        >
          {{ bread.name }}
        </p>
        @if (!$last) {
          <svg-icon class="flex h-4 w-4 px-1 text-base-gray-300" src="assets/icons/icon-arrow-right.svg"></svg-icon>
        }
      }
    </div>
  </div>
</app-modal-header>

<div app-modal-content class="h-[75vh] w-[70vw]">
  @if (data$ | async; as data) {
    @if (data.load) {
      <app-skeleton></app-skeleton>
    } @else if (data.storage | noEmpty) {
      <table app-table>
        <thead>
          <tr>
            <th app-table-cell class="bg-modules-eclass-500! text-left! text-white!" translate>servicos.drive.nome</th>
            <th app-table-cell class="w-24 bg-modules-eclass-500!"></th>
          </tr>
        </thead>
        <tbody app-table-body>
          @for (element of data.storage; track $index) {
            <tr class="rounded-lg shadow">
              <td app-table-cell>{{ nameElement(element.caminho) }}</td>
              <td app-table-cell class="text-center!">
                <button
                  app-icon-button
                  type="button"
                  class="rounded-full!"
                  [ngClass]="color(element.extensao)"
                  (click)="onView(element)"
                >
                  <svg-icon
                    class="flex h-7 w-7 text-white"
                    [src]="
                      !element.extensao || element.extensao === 'pasta'
                        ? 'assets/icons/icon-folder.svg'
                        : isVideo(element.extensao)
                          ? 'assets/icons/icon-play-filled.svg'
                          : 'assets/icons/icon-download.svg'
                    "
                  ></svg-icon>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <app-jumbotron translate>geral.nenhum-dado</app-jumbotron>
    }
  }
</div>
